import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsDelimiter',
  standalone: true,
})
export class ThousandsDelimiterPipe implements PipeTransform {
  transform(value: number): string {
    return value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') ?? '';
  }
}
